import React from 'react';
import { createBus } from 'suber'

const bus = createBus();

const withBus = (Component) => {
    if(!Component) {
        return null;
    }

    return (props) => (<Component {...props} bus={bus} />);
};

withBus.displayName = `withBus`;

export {
    withBus
};


// WEBPACK FOOTER //
// ./src/util/suber-hoc.js